import React from 'react';
import axios from 'axios';
import qs from 'qs';
import {withSnackbar} from 'notistack';
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {withCookies} from "react-cookie";
import {saveUserToStore} from "../../helpers";

const styles = () => ({
  contentWrapper: {
    maxWidth: 720,
  },
  resendEmailVerificationButton: {
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#f56a12',
    '&:hover': {
        backgroundColor: '#C24C03',
    },
  },
  confirmEmailVerificationButton: {
    marginLeft: 10,
    marginTop: 22,
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  resendEmailVerificationText: {
    color: '#E71133',
  }
});

class ParentVerifyEmail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailVerifyCode: ''
    };

    this.axiosCancel = null;

    this.handleResendEmailClick = this.handleResendEmailClick.bind(this);
    this.handleVerifyEmailClick = this.handleVerifyEmailClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleResendEmailClick() {
    const {
      enqueueSnackbar,
    } = this.props;

    axios
      .post(
        `${window.apiUrl}/resendverifyemail`,
        {},
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          enqueueSnackbar(response.data.data, {
            variant: 'success',
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  handleVerifyEmailClick() {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    axios
      .post(
        `${window.apiUrl}/verifyemail`,
        qs.stringify({
          code: this.state.emailVerifyCode,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          enqueueSnackbar(t('You have verified your email address, you can now use your account.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            emailVerifyCode: '',
          });

          const userData = response.data.data;
          saveUserToStore(userData);

          window.dispatchEvent(new CustomEvent(
            'parent:reload-app',
            {
              bubbles: true,
            }
          ));
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className={`parent-verify-email ${classes.contentWrapper}`}>
        <div className={classes.resendEmailVerificationText}>
          {t('You need to verify your email address before you can access your account.')}
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleResendEmailClick}
          className={`resend-verification-email-button ${classes.resendEmailVerificationButton}`}
        >
          {t('Resend verification email')}
        </Button>
        <div>
          <TextField
            id="emailVerifyCode"
            label={t('Email verification code')}
            margin="normal"
            type="text"
            name="emailVerifyCode"
            onChange={this.onInputChange}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleVerifyEmailClick}
            className={`verify-email-button ${classes.confirmEmailVerificationButton}`}
          >
            {t('Verify email')}
          </Button>
        </div>
      </div>
    );
  }
}


export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(ParentVerifyEmail))));
